module.exports = __webpack_public_path__ + "static/about5-a7a543f436d6d737718294e87355d2c9.jpg";